/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import firebase from "@/firebase/firebaseConfig.js";

import endpoints from "@/network/endpoints.js";
import Crypto from "@/helper/crypto.js";

export default {
  // API CALLS
  sendChatMessage({ commit, rootGetters, rootState }, payload) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat + "/chatMessages")
        .child(payload.room.chatUID)
        .push({
          text: payload.msg.text,
          timestamp: payload.msg.timestamp,
          isSeen: false,
          sendBy: payload.msg.sendBy,
          seenBy: {
            [payload.msg.sendBy.id]: {
              id: payload.msg.sendBy.id,
              name: payload.msg.sendBy.name,
              timestamp: payload.msg.timestamp,
            },
          },
        });

      // axios
      //   .post(
      //     endpoints.admin_send_chat_notification,
      //     {
      //       members: payload.room.members,
      //       room_id: payload.room.chatUID,
      //       body: payload.msg.text,
      //     },
      //     {
      //       headers: {
      //         Authorization: Crypto.decrypt(rootState.appUser.token),
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     resolve(response);
      //   })
      //   .catch((error) => {
      //     reject(error);
      //   });
    });
  },

  markSeenAllMessages({ getters, commit, rootState }, id) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat + "/chatMessages")
        .child(id)
        // .orderByChild("sendBy")
        // .equalTo("agent")
        .once("value", function(snapshot) {
          snapshot.forEach(function(child) {
            let message = child.val();
            if (message.sendBy !== `${rootGetters.getUser.id}`) child.ref.update({ isSeen: true });
          });
          resolve(true);
        });
    });
  },

  uploadImage({ commit, rootGetters, rootState }, payload) {
    return new Promise((resolve, reject) => {
      let metadata = {
        contentType: payload.msg.image.type,
      };
      let timestamp = Math.floor(Date.now() / 1000);
      const uploadImage = firebase
        .storage()
        .ref(endpoints.firebase_chat)
        .child(payload.room.chatUID + "/" + timestamp + "_" + payload.msg.image.name)
        .put(payload.msg.image, metadata)
        .then((snapshot) => {
          return snapshot.ref.getDownloadURL();
        })
        .then((snapshotUrl) => {
          firebase
            .database()
            .ref(endpoints.firebase_chat + "/chatMessages")
            .child(payload.room.chatUID)
            .push({
              text: payload.msg.text,
              image_url: snapshotUrl,
              timestamp: payload.msg.timestamp,
              isSeen: false,
              sendBy: payload.msg.sendBy,
              seenBy: {
                [payload.msg.sendBy.id]: {
                  id: payload.msg.sendBy.id,
                  name: payload.msg.sendBy.name,
                  timestamp: payload.msg.timestamp,
                },
              },
            });
        })
        .catch((error) => {
          console.log(error);
        });

      // axios
      //   .post(
      //     endpoints.admin_send_chat_notification,
      //     {
      //       members: payload.room.members,
      //       room_id: payload.room.chatUID,
      //       body: payload.msg.text ? payload.msg.text : "image",
      //     },
      //     {
      //       headers: {
      //         Authorization: Crypto.decrypt(rootState.appUser.token),
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     resolve(response);
      //   })
      //   .catch((error) => {
      //     reject(error);
      //   });
    });
  },

  // Get chat rooms from server. Also change in store
  fetchChatRooms({ commit, rootGetters, dispatch }) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat + "/chats")
        .orderByChild("members/" + rootGetters.getUser.id + "/active")
        .equalTo(true)
        .on("value", (snapshot) => {
          let _arr = [];
          let chatRooms = snapshot.val();
          if (chatRooms) {
            for (const [chatUID, chatRoom] of Object.entries(chatRooms)) {
              if (chatRoom) {
                _arr.push({
                  ...chatRoom,
                  chatUID: chatUID,
                });
              }
            }
          }
          commit("UPDATE_CHAT_ROOMS", _arr);
          dispatch("fetchChatMessage", _arr);
          resolve(_arr);
        });
    });
  },

  fetchChatMessage({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let _arr = {};
      payload.map((room) => {
        _arr[room.chatUID] = {
          isPinned: false,
          msg: [],
        };

        firebase
          .database()
          .ref(endpoints.firebase_chat + "/chatMessages/" + room.chatUID)
          .on("value", (snapshot) => {
            let chats = snapshot.val();
            for (const [messageUID, message] of Object.entries(chats)) {
              if (message) {
                _arr[room.chatUID].msg.push({
                  ...message,
                  messageUID: messageUID,
                });
              }
            }

            // update last sent message in chat room
            const lastMessage = Object.values(chats).pop();
            let params = { chatUID: room.chatUID, message: lastMessage };

            dispatch("updateLastMessage", params);
            // set chatRoom last updated
            dispatch("setLastUpdated", { chatUID: room.chatUID, timestamp: lastMessage.timestamp });
          });
        commit("UPDATE_CHATS", _arr);
        resolve(_arr);
      });
    });
  },
  updateChats({ commit }, payload) {
    commit("UPDATE_CHATS", payload);
  },
  updateLastMessage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat + "/chats")
        .child(payload.chatUID)
        .once("value", function(snapshot) {
          // commit("UPDATE_LAST_MESSAGE", payload);
          snapshot.ref.update({ lastSentMessage: payload.message });
          resolve(true);
        });
    });
  },

  markSeenMessages({ getters, rootGetters }, id) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat + "/chatMessages")
        .child(id)
        // .orderByChild("sendBy")
        // .equalTo("agent")
        .once("value", function(snapshot) {
          snapshot.forEach(function(child) {
            let message = child.val();
            let seen = false;
            for (const [key, value] of Object.entries(message.seenBy)) {
              if (key == rootGetters.getUser.id) seen = true;
            }
            if (!seen) {
              let seenBy = {
                ...message.seenBy,
                [rootGetters.getUser.id]: {
                  name: rootGetters.getUser.name,
                  timestamp: Math.round(new Date().getTime() / 1000),
                },
              };

              child.ref.update({ seenBy: seenBy });
            }
          });
          resolve(true);
        });
    });
  },
  setLastUpdated({}, payload) {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(endpoints.firebase_chat)
        .child("chats/" + payload.chatUID)
        .update({
          updatedAt: payload.timestamp,
        });

      resolve(true);
    });
  },
};
